import { useRef } from "react";
import type { MarketComponentMarketComponentIO } from "../generated/fresh-guard-api";
import useSendStatus from "./useSendStatus.ts";
import { useWebSocketSetup } from "./useWebSocketSetup.ts";

export function useWebSocket(
  onStatusUpdate: (
    marketComponents: MarketComponentMarketComponentIO[],
  ) => void,
) {
  const wsRef = useRef<WebSocket | null>(null);
  const keyRef = useRef<CryptoKey | null>(null);

  useWebSocketSetup({ wsRef, keyRef, onStatusUpdate });

  const sendStatus = useSendStatus(wsRef);

  return { sendStatus };
}
